/* eslint-disable no-unused-vars */
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import * as THREE from "three";
import stringHash from "string-hash";
import { SkeletonUtils } from "three/examples/jsm/utils/SkeletonUtils";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { v1 as uuidv1 } from "uuid";
import { buildGraph } from "./MachineHelper";
import { ACTION_TYPES, AR_PLATFORM, ASSET_TYPES, XR_MODES } from "../constants";
import allbox from "../configsForTranslator/boxSizeAll.json";
import height from "../configsForTranslator/heightGlb.json";
import allResize from "../configsForTranslator/allfinalresize.json";
import allcategory from "../configsForTranslator/allcategory.json";

const materialNodesMain = {};
const validateMap = {};
const loader = new GLTFLoader();
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("./draco/gltf/");
dracoLoader.preload();
loader.setDRACOLoader(dracoLoader);
const addAsset = (assets, url, type, urls) => {
  const hashed = stringHash(url);
  console.log("hashed", url, hashed);
  // eslint-disable-next-line no-param-reassign
  assets[hashed] = { type, url, urls };
  return hashed;
};

const checkMaterialNames = (materialName) => {
  let finalMaterialName = "";
  const { materials } = materialNodesMain;
  const allKeys = Object.keys(materials);
  for (let index = 0; index < allKeys.length; index += 1) {
    const keyName = allKeys[index];
    if (materialName.toLowerCase() === keyName.toLowerCase()) {
      finalMaterialName = keyName;
      break;
    }
  }
  return finalMaterialName;
};

const _ = require("lodash");
// const scaleDownFactor = 0.5;

// eslint-disable-next-line no-unused-vars
const getCordinateArray = (cordinateString) => {
  const stringArray = cordinateString.split(" ");
  return stringArray.map((val) => Number(val));
};
const isPowerOfTwo = (number) => {
  // eslint-disable-next-line no-bitwise
  return number && !(number & (number - 1));
};

const validateMaps = (skuId, glbUrl, materialNode) => {
  console.log("validatemaps", materialNode);
  if (materialNode != null && glbUrl != null && skuId != null) {
    let stringOutput = `${skuId},${glbUrl},`;
    validateMap.skuId = skuId;
    validateMap.glbUrl = glbUrl;
    Object.keys(materialNode).forEach((materialName) => {
      const material = materialNode[materialName];
      const mapKeys = Object.keys(material).filter(
        (key) =>
          key.toLowerCase().endsWith("map") &&
          material[key] instanceof THREE.Texture
      );
      const NPOT = mapKeys.filter(
        (mapKey) =>
          !isPowerOfTwo(material[mapKey].image.width) ||
          !isPowerOfTwo(material[mapKey].image.height)
      );
      const BIG = mapKeys.filter(
        (mapKey) =>
          material[mapKey].image.width > 2048 ||
          material[mapKey].image.height > 2048
      );
      if (NPOT.length > 0) {
        const npot = `NPOT-${materialName}`;
        const initialValue = validateMap.NPOT || [];
        validateMap.NPOT = [...initialValue, npot];
        stringOutput += `NPOT-${materialName},`;
      }
      if (BIG.length > 0) {
        const big = `NPOT-${materialName}`;
        const initialValue = validateMap.BIG || [];
        validateMap.BIG = [...initialValue, big];
        stringOutput += `BIG-${materialName},`;
      }
    });

    console.log("validatemaps", stringOutput);
  }
};

const getOpacityActionData = (outputConfig, value) => {
  // console.log("skutranslation getopacity", value);
  const Off = {
    opacity: 0,
    visible: false,
    // transparent: true,
  };
  const On = {
    opacity: 1,
    visible: true,
    // transparent: true,
  };
  // menuEntry.onClick.push(
  return {
    type: ACTION_TYPES.OPACITY,
    config: {
      [value.materialName]: Number(value.opacity) === 0 ? Off : On,
    },
  };
};

const getPlayAnimationActionData = (outputConfig, value) => {
  return {
    type: ACTION_TYPES.CLIP_ANIMATION,
    config: {
      clipName: value.clipToPlay,
      startFrame: Number(value.startFrame),
      endFrame: Number(value.endFrame),
    },
  };
};

// eslint-disable-next-line no-unused-vars
const getMaterialActionData = (assets, outputConfig, value, iconName) => {
  // console.info("skuTranslator vibhor", value);
  if (
    value.AOMapSource === "" &&
    value.textureSource === "" &&
    value.lightMapSource === "" &&
    value.normalMapSource === "" &&
    value.metallicMapSource === "" &&
    value.roughnessMapSource === ""
  ) {
    return null;
  }
  const materialObject = {};
  if (value.AOMapSource)
    materialObject.aoMap = addAsset(
      assets,
      value.AOMapSource,
      ASSET_TYPES.TEXTURE
    );
  if (value.textureSource)
    materialObject.map = addAsset(
      assets,
      value.textureSource,
      ASSET_TYPES.TEXTURE
    );
  if (value.lightMapSource)
    materialObject.lightMap = addAsset(
      assets,
      value.lightMapSource,
      ASSET_TYPES.TEXTURE
    );
  if (value.normalMapSource)
    materialObject.normalMap = addAsset(
      assets,
      value.normalMapSource,
      ASSET_TYPES.TEXTURE
    );
  if (value.metallicMapSource)
    materialObject.metallicMap = addAsset(
      assets,
      value.metallicMapSource,
      ASSET_TYPES.TEXTURE
    );
  if (value.roughnessMapSource)
    materialObject.roughnessMap = addAsset(
      assets,
      value.roughnessMapSource,
      ASSET_TYPES.TEXTURE
    );

  // menuEntry.onClick.push(
  return {
    type: ACTION_TYPES.MATERIALS,
    config: {
      [value.materialName]: materialObject,
    },
  };
};

const mergeObject = (sourceObject, objectToAdd) => {
  if (!objectToAdd) return sourceObject;
  // console.log("merge", JSON.stringify(sourceObject), JSON.stringify(objectToAdd))
  let objectToMerge = null;
  sourceObject.forEach((actionTrigger) => {
    if (actionTrigger.type === objectToAdd.type) objectToMerge = actionTrigger;
  });
  if (objectToMerge == null) sourceObject.push(objectToAdd);
  else {
    objectToMerge = _.merge(objectToMerge, objectToAdd);
  }
  // console.log("mergeout", JSON.stringify(sourceObject))
  return sourceObject;
};

const getMenuEntry = (assets, v0Config, outputConfig, buttonData) => {
  // console.log("running for ", buttonData)
  const menuEntry = {
    name: buttonData.iconName,
    menu: [],
    icon: buttonData.defaultIconSource,
    iconSelected: buttonData.selectedIconSource,
    onClick: [],
    onUnClick: [],
    default: 0,
  };
  const meshMaterialData = v0Config.modifyMeshMaterial;
  const playAnimationData = v0Config.playAnimation;
  const materialOpacityData = v0Config.materialOpacity;
  if (buttonData["3D_Actions"] instanceof Array)
    buttonData["3D_Actions"].forEach((action) => {
      if (action === "materialOpacity") {
        const opacityActionObject = materialOpacityData[buttonData.iconName];
        if ("3D_Actions_Selected" in opacityActionObject) {
          Object.entries(opacityActionObject["3D_Actions_Selected"]).forEach(
            ([, value]) => {
              if ("materialName" in value) {
                mergeObject(
                  menuEntry.onClick,
                  getOpacityActionData(outputConfig, value)
                );
                // menuEntry.onClick.push(getOpacityActionData(outputConfig, value))
              }
            }
          );
        }
        if ("3D_Actions_UnSelected" in opacityActionObject) {
          Object.entries(opacityActionObject["3D_Actions_UnSelected"]).forEach(
            ([, value]) => {
              if ("materialName" in value) {
                // menuEntry.onUnClick.push(getOpacityActionData(outputConfig, value))
                mergeObject(
                  menuEntry.onUnClick,
                  getOpacityActionData(outputConfig, value)
                );
              }
            }
          );
        }
      }
      if (action === "modifyMeshMaterial") {
        const materialActionObject = meshMaterialData[buttonData.iconName];
        if ("3D_Actions_Selected" in materialActionObject) {
          Object.entries(materialActionObject["3D_Actions_Selected"]).forEach(
            ([, value]) => {
              if ("materialName" in value) {
                mergeObject(
                  menuEntry.onClick,
                  getMaterialActionData(
                    assets,
                    outputConfig,
                    value,
                    buttonData.iconName
                  )
                );
              }
            }
          );
        }
        if ("3D_Actions_UnSelected" in materialActionObject) {
          Object.entries(materialActionObject["3D_Actions_UnSelected"]).forEach(
            ([, value]) => {
              if ("materialName" in value) {
                mergeObject(
                  menuEntry.onUnClick,
                  getMaterialActionData(
                    assets,
                    outputConfig,
                    value,
                    buttonData.iconName
                  )
                );
              }
            }
          );
        }
      }
      if (action === "playAnimation") {
        const playAnimationActionObject =
          playAnimationData[buttonData.iconName];
        if ("3D_Actions_Selected" in playAnimationActionObject) {
          Object.entries(
            playAnimationActionObject["3D_Actions_Selected"]
          ).forEach(([, value]) => {
            menuEntry.onClick.push(
              getPlayAnimationActionData(outputConfig, value)
            );
            // mergeObjectForAnimation(
            //   menuEntry.onClick,
            //   getPlayAnimationActionData(outputConfig, value)
            // );
          });
        }
        if ("3D_Actions_UnSelected" in playAnimationActionObject) {
          Object.entries(
            playAnimationActionObject["3D_Actions_UnSelected"]
          ).forEach(([, value]) => {
            menuEntry.onUnClick.push(
              getPlayAnimationActionData(outputConfig, value)
            );
            // mergeObjectForAnimation(
            //   menuEntry.onUnClick,
            //   getPlayAnimationActionData(outputConfig, value)
            // );
          });
        }
      }
    });

  return menuEntry;
};

const addParentMenu = (
  assets,
  v0Config,
  outputConfig,
  buttonData,
  uiConfig
) => {
  uiConfig.menu.push(getMenuEntry(assets, v0Config, outputConfig, buttonData));
};

const addChildMenu = (
  assets,
  v0Config,
  outputConfig,
  buttonData,
  uiConfig,
  parentIconName
) => {
  let parentMenuItem = null;
  uiConfig.menu.forEach((firstLevelButton) => {
    if (firstLevelButton.name === parentIconName)
      parentMenuItem = firstLevelButton;
  });
  if (parentMenuItem == null) return;
  parentMenuItem.menu.push(
    getMenuEntry(assets, v0Config, outputConfig, buttonData)
  );
};

const loadGLB = async (path, setBoxSize, setNodeMaterialObject) => {
  return new Promise((resolve) => {
    let boxSize = new THREE.Vector3();
    loader.load(
      path,
      (gltf) => {
        const clonedObject = SkeletonUtils.clone(gltf.scene);
        const nodeMaterialObject = buildGraph(clonedObject);
        console.log("gltf skutranslator", gltf.scene);
        const box = new THREE.Box3().setFromObject(gltf.scene);
        boxSize = box.getSize(boxSize);
        console.log("ARModelXXX centerAndScale translator size", boxSize);
        setBoxSize(boxSize);
        setNodeMaterialObject(nodeMaterialObject);
        resolve();
      },
      () => {
        // console.log(`${(xhr.loaded / xhr.total) * 100}% loaded`);
      },
      (error) => {
        console.log("An error happened", error);
        resolve();
      }
    );
  });
};
const skuTranslatorV0V1 = async (v0Config, skuId) => {
  const orderForCategories = [
    "gold",
    "seating",
    "table",
    "dining",
    "cabinetry",
    "bed",
    "sofa",
    "chair",
    "decor",
  ];
  const assets = {};
  // materialNodesMain = {};
  // Object.keys(assets).forEach((key) => delete assets[key]);
  // Object.keys(materialNodesMain).forEach(
  //   (key1) => delete materialNodesMain[key1]
  // );
  // Object.keys(validateMap).forEach((key2) => delete validateMap[key2]);
  let countOfIcons = 0; // SSD : keep track of no of icons
  const listOfIcons = [];
  const outputConfig = {};
  outputConfig.skuId = skuId;
  outputConfig.models = {};
  outputConfig.renderer = {};
  outputConfig.ambientLight = {};
  outputConfig.directionalLights = [];
  outputConfig.camera = {};
  outputConfig.orbitControls = {};
  outputConfig.cameraControls = {};
  outputConfig.version = "V0";
  outputConfig.uiConfig = {};
  outputConfig.positionTexture = addAsset(
    assets,
    "https://web2.avataar.me/common/ar_floor_placement_grid.png",
    ASSET_TYPES.TEXTURE
  );
  // let ambientLightDefault =1;
  // let envMapExposureDefault = 4;
  if (v0Config.backgroundColor) {
    outputConfig.backgroundColor = v0Config.backgroundColor;
  }
  //   ambientLightDefault = 1.5;
  //   envMapExposureDefault = 2.3;
  // }

  // models
  let data = v0Config.glb;
  if (skuId in allResize) {
    data = `https://d77dh4faztz32.cloudfront.net/prakhar_test_glbs/${skuId}/resize_glb_2048_${skuId}.glb`;
  }

  // const data = "./models/resize_glb_1024_1745297.glb";
  // const data = `https://d77dh4faztz32.cloudfront.net/prakhar_test_glbs/${skuId}/resize_glb_1024_${skuId}.glb`;
  if (data) {
    outputConfig.models = {};
    outputConfig.models.path = addAsset(assets, data, ASSET_TYPES.GLTF);
    outputConfig.models.ar = true;
    outputConfig.models.config = {};
    outputConfig.models.materials = {};
    // await loadGLB(
    //   data,
    //   (boxSize) => {
    //     console.log("loading calling", boxSize);
    //     outputConfig.models.boxSize = boxSize;
    //   },
    //   (nodeObject) => {
    //     console.log("nodematerial", nodeObject);
    //     materialNodesMain = nodeObject;
    //   }
    // );
    // validateMaps(skuId, data, materialNodesMain.materials);
  }

  // model config
  let scale = null;
  if ("arScale" in v0Config && v0Config.arScale.split(" ")[0]) {
    scale = Number(v0Config.arScale.split(" ")[0]);
  }
  const y = allbox[skuId];
  const h = Number(height[skuId]);
  if (scale) {
    if (y && h) {
      const heightOfModel = Number(y.y);
      const newscale = ((h * 0.0254) / heightOfModel).toFixed(2);
      if (newscale <= 1.5 && newscale >= 0.9) {
        scale = 1;
      } else {
        scale = Number(newscale);
      }
      scale = scale.toFixed(3);
    } else if (scale > 2 && scale < 7) {
      scale = 1;
    } else scale /= 5;
  } else {
    scale = 1;
  }
  scale = Number(scale).toFixed(4);
  scale = Number(scale);

  outputConfig.models.config = {
    scale,
    // scale: 1,
    // "position": getCordinateArray(v0Config["xrPosition"]),
    // "position": transformCorrection(getCordinateArray(v0Config["xrPosition"]), posCorrectionFactor),
    position: [0, 0, 0],
    rotation: [0, 0, 0],
  };

  // default color icon
  const defColIcon = v0Config.iconselectedonload;
  const { isDimOn } = v0Config;

  const uiConfig = {};
  uiConfig.name = "firstLayer";
  uiConfig.menu = [];
  uiConfig.default = 1;
  uiConfig.isDimensionOn = false;
  uiConfig.onLoad = {
    [XR_MODES.XR]: {
      [AR_PLATFORM.THREEJS]: [],
    },
    [XR_MODES.AR]: {
      [AR_PLATFORM.EIGHTHWALL]: [],
      [AR_PLATFORM.WEBXR]: [],
    },
  };
  // def color
  if (defColIcon) {
    uiConfig.defaultColor = defColIcon;
  }

  // def-dim on/off check
  if (isDimOn) {
    uiConfig.isDimensionOn = true;
  }
  // icon list
  const iconListData = v0Config.iconList || {};
  const playAnimationData = v0Config.playAnimation;
  const materialOpacityData = v0Config.materialOpacity;
  const meshMaterialData = v0Config.modifyMeshMaterial;
  // parse parent level
  Object.keys(iconListData).forEach((key) => {
    const buttonData = iconListData[key];
    countOfIcons += 1;
    if (!listOfIcons.includes(buttonData.iconName)) {
      // SSD : Outer loop to check if icon already added
      listOfIcons.push(buttonData.iconName);
      if (buttonData.parentIcon === "") {
        addParentMenu(assets, v0Config, outputConfig, buttonData, uiConfig);
      }
    }
  });
  // SSD : if only 1 icon is present check,
  if (countOfIcons <= uiConfig.default) {
    uiConfig.default = countOfIcons - 1;
  }

  // parse child level
  Object.keys(iconListData).forEach((key) => {
    const buttonData = iconListData[key];
    // parent level
    if (buttonData.parentIcon !== "") {
      addChildMenu(
        assets,
        v0Config,
        outputConfig,
        buttonData,
        uiConfig,
        buttonData.parentIcon
      );
    }
  });

  // modify fullempty order
  if (uiConfig.menu.length > 0) {
    const fullIndex = uiConfig.menu.findIndex(
      (e) => e.name === "fullEmptyIcon"
    );
    const openIndex = uiConfig.menu.findIndex(
      (e) => e.name === "openCloseIcon"
    );
    if (fullIndex !== -1 && openIndex !== -1 && fullIndex < openIndex) {
      const temp = uiConfig.menu[fullIndex];
      uiConfig.menu[fullIndex] = uiConfig.menu[openIndex];
      uiConfig.menu[openIndex] = temp;
    }
  }

  outputConfig.uiConfig = uiConfig;

  // parse onLoad actions
  if (v0Config.onLoad3DActions) {
    v0Config.onLoad3DActions.forEach((actionType) => {
      if (actionType === "materialOpacity") {
        if (materialOpacityData) {
          const opacityActionObject = materialOpacityData.onLoad3DActions;
          if (opacityActionObject) {
            if ("3D_Actions_Selected" in opacityActionObject) {
              Object.entries(
                opacityActionObject["3D_Actions_Selected"]
              ).forEach(([, value]) => {
                if ("materialName" in value) {
                  mergeObject(
                    outputConfig.uiConfig.onLoad[XR_MODES.XR][
                      AR_PLATFORM.THREEJS
                    ],
                    getOpacityActionData(outputConfig, value)
                  );
                  mergeObject(
                    outputConfig.uiConfig.onLoad[XR_MODES.AR][
                      AR_PLATFORM.EIGHTHWALL
                    ],
                    getOpacityActionData(outputConfig, value)
                  );
                  mergeObject(
                    outputConfig.uiConfig.onLoad[XR_MODES.AR][
                      AR_PLATFORM.WEBXR
                    ],
                    getOpacityActionData(outputConfig, value)
                  );
                  // outputConfig["onLoad"].push(getOpacityActionData(outputConfig, value))
                }
              });
            }
          }
        }
      }
      if (meshMaterialData && actionType === "modifyMeshMaterial") {
        const materialActionObject = meshMaterialData.onLoad3DActions;
        if (
          materialActionObject &&
          "3D_Actions_Selected" in materialActionObject
        ) {
          Object.entries(materialActionObject["3D_Actions_Selected"]).forEach(
            ([key, value]) => {
              if ("materialName" in value) {
                // console.log("skutranslator vibhor onload");
                mergeObject(
                  outputConfig.uiConfig.onLoad[XR_MODES.XR][
                    AR_PLATFORM.THREEJS
                  ],
                  getMaterialActionData(assets, outputConfig, value, "onload")
                );
                mergeObject(
                  outputConfig.uiConfig.onLoad[XR_MODES.AR][
                    AR_PLATFORM.EIGHTHWALL
                  ],
                  getMaterialActionData(assets, outputConfig, value, "onload")
                );
                mergeObject(
                  outputConfig.uiConfig.onLoad[XR_MODES.AR][AR_PLATFORM.WEBXR],
                  getMaterialActionData(assets, outputConfig, value, "onload")
                );
              }
            }
          );
        }
      }
      if (actionType === "playAnimation") {
        if (playAnimationData) {
          const playAnimationActionObject = playAnimationData.onLoad3DActions;
          if (playAnimationActionObject) {
            if ("3D_Actions_Selected" in playAnimationActionObject) {
              const totalLength = Object.entries(
                playAnimationActionObject["3D_Actions_Selected"]
              ).length;
              Object.entries(
                playAnimationActionObject["3D_Actions_Selected"]
              ).forEach(([, value], index) => {
                // mergeObjectForAnimation(
                //   outputConfig["onLoad"],
                //   getPlayAnimationActionData(outputConfig, value)
                // );
                const clipConfigOnLoad = getPlayAnimationActionData(
                  outputConfig,
                  value
                );
                clipConfigOnLoad.config.clampFinishFlag = true;
                if (index === totalLength - 1 && skuId in allcategory.bed) {
                  clipConfigOnLoad.config.clampFinishFlag = false;
                }
                outputConfig.uiConfig.onLoad[XR_MODES.XR][
                  AR_PLATFORM.THREEJS
                ].push(clipConfigOnLoad);
              });
            }
          }
        }
      }
    });
  }

  const dynamicOnLoadObject = {
    type: ACTION_TYPES.DYNAMIC_ANIMATION,
    config: {
      name: "rotate",
      duration: 4000,
      angle: Math.PI * 2,
      delay: 1000,
    },
  };

  outputConfig.uiConfig.onLoad[XR_MODES.XR][AR_PLATFORM.THREEJS].splice(
    1,
    0,
    dynamicOnLoadObject
  );
  // console.log(
  //   "skuTranslator vibhor",
  //   outputConfig.uiConfig.onLoad[XR_MODES.XR][AR_PLATFORM.THREEJS]
  // );
  const onLoadData =
    outputConfig.uiConfig.onLoad[XR_MODES.XR][AR_PLATFORM.THREEJS];
  outputConfig.uiConfig.onLoad[XR_MODES.XR][AR_PLATFORM.THREEJS] = [];
  [
    ACTION_TYPES.OPACITY,
    ACTION_TYPES.MATERIALS,
    ACTION_TYPES.DYNAMIC_ANIMATION,
    ACTION_TYPES.CLIP_ANIMATION,
  ].forEach((actionType) => {
    const onloadObject = onLoadData.find((e) => e.type === actionType);
    if (onloadObject)
      outputConfig.uiConfig.onLoad[XR_MODES.XR][AR_PLATFORM.THREEJS].push(
        onloadObject
      );
  });
  console.log(
    "skuTranslator vibhor",
    outputConfig.uiConfig.onLoad[XR_MODES.XR][AR_PLATFORM.THREEJS]
  );
  // outputConfig.uiConfig.onLoad.splice(1, 0, additionalMaterialChange);

  // renderer settings
  // v0Config.rendererSettings.split(";").forEach((rendererSetting) => {
  //   const keyVal = rendererSetting.split(":");
  //   if (keyVal.length === 2)
  //     outputConfig.renderer[keyVal[0]] = Boolean(keyVal[1]);
  // });
  outputConfig.renderer = {
    antialias: true,
    colorManagement: true,
    sortObjects: true,
    physicallyCorrectLights: true,
  };

  // ambient light
  let ambientLightIntensity = 2;
  if (v0Config.ambientLightSettings) {
    if ("lightIntensity" in v0Config.ambientLightSettings)
      ambientLightIntensity = v0Config.ambientLightSettings.lightIntensity;
    else {
      const key = Object.keys(v0Config.ambientLightSettings)[0];
      ambientLightIntensity = v0Config.ambientLightSettings[key].lightIntensity;
    }
  }
  if (!ambientLightIntensity) ambientLightIntensity = 2;
  //   Object.entries(v0Config.ambientLightSettings).forEach(([, value]) => {
  outputConfig.ambientLight = {
    [XR_MODES.XR]: {
      [AR_PLATFORM.THREEJS]: {
        // color: value.color,
        color: 0xffffff,
        intensity: ambientLightIntensity,
        // intensity: value.lightIntensity,
      },
    },
    [XR_MODES.AR]: {
      [AR_PLATFORM.EIGHTHWALL]: {
        // color: value.color,
        color: 0xffffff,
        intensity: 1,
        // intensity: value.lightIntensity,
      },
      [AR_PLATFORM.WEBXR]: {
        // color: value.color,
        color: 0xffffff,
        intensity: ambientLightIntensity,
        // intensity: value.lightIntensity,
      },
    },
  };
  // });

  // toneMapping
  outputConfig.toneMapping = {
    [XR_MODES.XR]: {
      [AR_PLATFORM.THREEJS]: {
        enableToneMapping: true,
        toneMappingExposure: 1.8,
      },
    },
    [XR_MODES.AR]: {
      [AR_PLATFORM.EIGHTHWALL]: {
        enableToneMapping: true,
        toneMappingExposure: 1,
      },
      [AR_PLATFORM.WEBXR]: {
        enableToneMapping: true,
        toneMappingExposure: 2,
      },
    },
  };

  // directional light
  // Object.entries(v0Config.directionalLightSettings).forEach(([, value]) => {
  // if (typeof value === typeof Object)
  let directionalightIntensity = 2.5;
  if (v0Config.directionalLightSettings) {
    if ("a0" in v0Config.directionalLightSettings) {
      directionalightIntensity =
        v0Config.directionalLightSettings.a0.lightIntensity;
    } else if ("lightIntensity" in v0Config.directionalLightSettings)
      directionalightIntensity =
        v0Config.directionalLightSettings.lightIntensity;
  }
  if (!directionalightIntensity) directionalightIntensity = 2.5;
  console.log("vibhor skutran", directionalightIntensity);
  outputConfig.directionalLights = {
    [XR_MODES.XR]: {
      [AR_PLATFORM.THREEJS]: [
        {
          // color: value.color,
          color: "#FFF",
          // intensity: value.lightIntensity,
          intensity: 0,
          // position: getCordinateArray(value.lightPosition),
          position: [0, 4, 4],
          // castShadow: value.castShadow,
          castShadow: true,

          "shadow-mapSize-height": 2048,
          "shadow-mapSize-width": 2048,
          "shadow-camera-top": 10,
          customId: uuidv1(),
        },
      ],
    },
    [XR_MODES.AR]: {
      [AR_PLATFORM.EIGHTHWALL]: [
        {
          // color: value.color,
          color: "#FFF",
          // intensity: value.lightIntensity,
          intensity: 1.8,
          // position: getCordinateArray(value.lightPosition),
          position: [0, 6, 0],
          // castShadow: value.castShadow,
          castShadow: true,
          "shadow-mapSize-height": 2048,
          "shadow-mapSize-width": 2048,
          "shadow-camera-top": 10,
          customId: uuidv1(),
        },
      ],
      [AR_PLATFORM.WEBXR]: [
        {
          // color: value.color,
          color: "#FFF",
          // intensity: value.lightIntensity,
          intensity: directionalightIntensity,
          // position: getCordinateArray(value.lightPosition),
          position: [0, 6, 0],
          // castShadow: value.castShadow,
          castShadow: true,
          "shadow-mapSize-height": 2048,
          "shadow-mapSize-width": 2048,
          "shadow-camera-top": 10,
          customId: uuidv1(),
        },
      ],
    },
  };

  // environment lighting
  let obj = {};
  if (v0Config.cubemapForImageBasedLighting) {
    const url = v0Config.cubemapForImageBasedLighting.negx;
    const pathurl = `${url.split("/").slice(0, -1).join("/")}/`;
    const urls = [
      v0Config.cubemapForImageBasedLighting.posx,
      v0Config.cubemapForImageBasedLighting.negx,
      v0Config.cubemapForImageBasedLighting.posy,
      v0Config.cubemapForImageBasedLighting.negy,
      v0Config.cubemapForImageBasedLighting.posz,
      v0Config.cubemapForImageBasedLighting.negz,
    ];
    obj = {
      lightURL: addAsset(assets, pathurl, ASSET_TYPES.CUBE_MAP, urls),
      name: url.split("/").slice(-2, -1)[0],
      // name: "HDR_CUBEMAP",
      type: ASSET_TYPES.CUBE_MAP,
    };
  } else {
    const url = "https://d77dh4faztz32.cloudfront.net/cubemap/newcubemap/";
    const urls = [
      "https://d77dh4faztz32.cloudfront.net/cubemap/newcubemap/px.jpg",
      "https://d77dh4faztz32.cloudfront.net/cubemap/newcubemap/nx.jpg",
      "https://d77dh4faztz32.cloudfront.net/cubemap/newcubemap/py.jpg",
      "https://d77dh4faztz32.cloudfront.net/cubemap/newcubemap/ny.jpg",
      "https://d77dh4faztz32.cloudfront.net/cubemap/newcubemap/pz.jpg",
      "https://d77dh4faztz32.cloudfront.net/cubemap/newcubemap/nz.jpg",
    ];
    obj = {
      lightURL: addAsset(assets, url, ASSET_TYPES.CUBE_MAP, urls),
      // name: url.split("/").slice(-2, -1)[0],
      name: "CUBEMAP_DEFAULT",
      type: ASSET_TYPES.CUBE_MAP,
    };
  }
  let updatedexposure = Math.max(directionalightIntensity * 2 - 2.5, 1.5);
  for (let i = 0; i < orderForCategories.length; i += 1) {
    const category = orderForCategories[i];
    if (skuId in allcategory[category]) {
      if (category === "gold") {
        updatedexposure = 4;
      } else if (
        category === "dining" ||
        category === "cabinetry" ||
        category === "table"
      ) {
        updatedexposure = 1.5;
      } else if (category === "bed") {
        updatedexposure = 2;
      } else if (category === "seating") {
        updatedexposure = Math.max(directionalightIntensity * 2 - 3, 1);
      } else if (
        category === "decor" ||
        category === "sofa" ||
        category === "chair"
      ) {
        updatedexposure = Math.max(directionalightIntensity * 2 - 2.5, 1);
      }
      break;
    }
  }

  if (v0Config.backgroundColor) {
    if (v0Config.backgroundColor.toLowerCase() === "#7a7a7a") {
      updatedexposure = 2;
    } else if (v0Config.backgroundColor.toLowerCase() === "#d3d3d3") {
      updatedexposure = 4;
    }
  }

  console.log("exposurep", updatedexposure, directionalightIntensity);

  outputConfig.environmentLight = {
    [XR_MODES.XR]: {
      [AR_PLATFORM.THREEJS]: {
        ...obj,
        exposure: updatedexposure,
      },
    },
    [XR_MODES.AR]: {
      [AR_PLATFORM.EIGHTHWALL]: {
        ...obj,
        // exposure: 3.0,
        // toneMapping: THREE.ReinhardToneMapping,
      },
      [AR_PLATFORM.WEBXR]: {
        ...obj,
        // exposure: 3.0,
        // toneMapping: THREE.ReinhardToneMapping,
      },
    },
  };

  // camera settings
  outputConfig.camera = {
    // position: getCordinateArray(v0Config.xrCameraPosition),
    // "position": [0,0,100],
    // far: 10000,
    // near: 0.01,
    // far: Number(v0Config.fovCameraFar),
    // near: Number(v0Config.fovCameraNear),
    fov: 45,
  };

  // orbit controls
  outputConfig.orbitControls = {
    enableZoom: true,
    enablePan: false,
    dampingFactor: 0.03,
    enableDamping: false,
    rotateSpeed: 0.8,
    enableRotate: true,
    zoomSpeed: 0.5,
    minPolarAngle: 0,
    maxPolarAngle: Math.PI / 2,
  };
  outputConfig.assets = assets;
  // console.log("translate config", outputConfig);
  return outputConfig;
};

const validateMapFn = async () => {
  console.log("translatevalidate", validateMap);
  return validateMap;
};

// exports.skuTranslator_v0_v1 = skuTranslator_v0_v1;
export default skuTranslatorV0V1;
export const validate = validateMapFn;
